import axios from 'axios';

export async function login(identifier: string, password: string, google_authenticator_token: string) {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
    identifier,
    password,
    google_authenticator_token,
    role: 'admin',
  })
  const { message } = response.data;
  const { token, user } = response.data.responseObject;

  return {
    token,
    user,
    message,
  }
}

// Added reset password API function following the same pattern as login
export async function resetPassword(password: string, confirmPassword: string, token: string) {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
    new_password: password,
    confirm_password: confirmPassword,
    token,
  })
  const { message } = response.data;
  const { token: respToken, user } = response.data.responseObject || {};

  return {
    token: respToken,
    user,
    message,
  }
}
